var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('container',{staticClass:"py-8 px-4"},[_c('list-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }